// ============================
// ALL ABOUTSEC2 PAGE DATA
// SEPARATED INTO A SINGLE FILE
// ============================

export const industriesData = [
  {
    icon: "/assets/icons/investment.png",
    title: "Investment Strategy",
    text: "Develop comprehensive investment strategies aligned with your objectives and risk tolerance.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Risk & Compliance",
    text: "Robust risk management frameworks ensuring regulatory compliance and protection.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Portfolio Optimization",
    text: "Advanced portfolio construction techniques to maximize risk-adjusted returns.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Performance Analytics",
    text: "Comprehensive performance measurement and attribution analysis for informed decisions.",
  },
];

// ============================
// DEFAULT ABOUT PAGE DATA
// ============================
export const defaultData = [
  {
    icon: "assets/icons/Precision.png",
    title: "Strategic Transparency",
    text: "We aim to create organizations where financial clarity is engineered through predictive analytics and resilient governance models.",
  },
  {
    icon: "assets/icons/Swift.png",
    title: "Resilient Growth",
    text: "Our vision is to help businesses scale through structures that balance capital efficiency, risk optimization, and market adaptability.",
  },
  {
    icon: "assets/icons/GrowthwithIntegrity.png",
    title: "Integrity Leadership",
    text: "We strive to set new standards in advisory ethics through independent thinking and evidence-backed guidance.",
  },
];

// ============================
// HEALTHCARE
// ============================
export const healthcareData = [
  {
    icon: "/assets/icons/investment.png",
    title: "Care Optimization",
    text: "Evaluating clinical processes to reduce inefficiencies, improve patient flow, and strengthen overall service quality.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Financial Resilience",
    text: "We help healthcare institutions stabilize revenue, control operational costs, and create long-term financial plans.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Digital Careflows",
    text: "Make hospitals adopt practical technologies – EHR upgrades, automation, analytics to improve patient experience.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Compliance Integrity",
    text: "With simplified regulatory requirements and governance structures, we keep healthcare operations protected.",
  },
];

// ============================
// OIL & GAS
// ============================
export const oilAndGasData = [
  {
    icon: "/assets/icons/investment.png",
    title: "Asset Valuation",
    text: "We assess the financial health and long-term value of energy assets to support smarter investment and divestment decisions.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Capital Structuring",
    text: "We help energy companies optimize funding strategies, manage capital flows, and structure projects.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Regulatory Compliance",
    text: "We navigate global energy regulations, reporting frameworks, and sustainability to ensure aligned, audit-ready financial operations.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Operational Efficiency",
    text: "We identify cost leakages across processing, transport, and distribution, enabling energy businesses to improve margins.",
  },
];

// ============================
// POWER & UTILITIES
// ============================
export const powerUtilitiesSectorData = [
  {
    icon: "/assets/icons/investment.png",
    title: "Energy Market Analysis",
    text: "We decode regional demand patterns, tariff structures, and regulatory shifts to guide investment and planning decisions.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Asset Advisory",
    text: "From grid modernization to plant performance upgrades, we help utilities enhance asset reliability and long-term value.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Operational Transformation",
    text: "We streamline distribution operations through digital integration, automation, and predictive analytics for higher efficiency.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Compliance Support",
    text: "We help you navigate energy laws, licensing requirements, filings, and sustainability mandates with confidence.",
  },
];

// ============================
// WASTE MANAGEMENT
// ============================
export const wasteManagementData = [
  {
    icon: "/assets/icons/investment.png",
    title: "Circular Economy Insights",
    text: "Strategies that reduce waste generation and push organizations toward reuse, recovery, and sustainability.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "ESG Alignment",
    text: "Guidance to meet local waste-compliance laws while strengthening ESG reporting and environmental performance.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Operational Planning",
    text: "Process improvements for collection, segregation, recycling, and disposal to reduce costs and increase throughput.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Technology Solutions",
    text: "Advisory on digital tracking, smart bins, automation, and analytics that improve accuracy and reduce operational risk.",
  },
];

// ============================
// MINING & MINERALS
// ============================
export const miningAndMineralsData = [
  {
    icon: "/assets/icons/investment.png",
    title: "Geological Assessment",
    text: "Helping mining companies strengthen investment decisions through clear financial insights.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "ESG Compliance",
    text: "Guiding miners through strict environmental and safety frameworks that reduce long-term risk.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Extraction Efficiency",
    text: "Improving extraction efficiency and reducing waste through data-led operational assessments.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Commodity Risk",
    text: "Strengthening resilience across procurement, logistics, and export channels for stability in volatile commodity markets.",
  },
];

// ============================
// ASSET MANAGEMENT
// ============================
export const assetManagementData = [
  {
    icon: "/assets/icons/investment.png",
    title: "Operational Resilience",
    text: "Digitized workflows cut processing errors, streamline reporting cycles, and lower operational costs.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Risk Intelligence",
    text: "Real-time analytics enhance exposure monitoring, improve scenario planning, and support more informed decision-making.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Portfolio Discipline",
    text: "Stronger allocation frameworks help asset managers respond to market shifts faster and reduce concentration risk.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Client Clarity",
    text: "Enhanced transparency, simplified reporting, and data-backed insights strengthen client retention in competitive markets.",
  },
];

// ============================
// BANKING
// ============================
export const bankingData = [
  {
    icon: "/assets/icons/investment.png",
    title: "Credit Stability",
    text: "Stronger credit assessment models using early-warning triggers and market data to protect lending quality.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Digital Railways",
    text: "Modernizing core banking with secure digital rails that improve transaction speed & reduce manual friction.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Lean Operations",
    text: "Optimizing branch networks and capital allocation to deliver measurable reductions in operating costs.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Customer Intelligence",
    text: "Transforming customer data into actionable insights that elevate financial products and strengthen lifetime value.",
  },
];

// ============================
// FINANCIAL ADVISORY
// ============================
export const financialAdvisoryData = [
  {
    icon: "/assets/icons/investment.png",
    title: "Capital Strategy",
    text: "Clear guidance on funds allocation wisely, strengthen cash flow, and plan investments with long-term value in mind.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Risk Review",
    text: "Simple, structured evaluation of financial risks with practical steps to reduce financial uncertainty and protect performance.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Performance Insights",
    text: "Straightforward analysis that highlights what’s working, what isn’t, and how to improve financial efficiency.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Growth Planning",
    text: "Actionable strategies that help businesses scale sustainably with stronger financial discipline and predictable outcomes.",
  },
];

// ============================
// FINANCIAL SERVICE TAX
// ============================
export const financialServiceTaxData = [
  {
    icon: "/assets/icons/investment.png",
    title: "Compliance Accuracy",
    text: "Ensuring filings, disclosures, and documentation meet regulatory standards with zero guesswork.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Risk Control",
    text: "Identifying exposure areas early and creating tax frameworks that reduce financial and legal risks.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Value Planning",
    text: "Guiding businesses toward tax-efficient structures that improve cash flow and long-term profitability.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Global Alignment",
    text: "Supporting cross-border operations with tax strategies that stay consistent across jurisdictions.",
  },
];

// ============================
// FINTECH
// ============================
export const fintechData = [
  {
    icon: "/assets/icons/investment.png",
    title: "Revenue Models",
    text: "We assess pricing, transaction margins, and product monetization to help FinTechs unlock sustainable revenue streams.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Risk Controls",
    text: "We strengthen AML/KYC systems, fraud detection flows, and operational controls to ensure regulatory-ready operations.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Data Intelligence",
    text: "We use financial analytics to improve credit decisions, customer segmentation, and product efficiency.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Scalable Systems",
    text: "We guide platform upgrades, API ecosystems, and financial infrastructure needed for rapid digital expansion.",
  },
];

// ============================
// INSURANCE
// ============================
export const insuranceData = [
  {
    icon: "/assets/icons/investment.png",
    title: "Risk Modeling",
    text: "Sharper analytics to improve pricing accuracy, strengthen underwriting, and reduce exposure across portfolios.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Capital Optimization",
    text: "Practical frameworks that improve solvency ratios, allocate capital effectively, and drive long-term stability.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Process Efficiency",
    text: "Modernizing claims, underwriting, and policy workflows to reduce delays, lower costs, and improve customer outcomes.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Regulatory Readiness",
    text: "Clear, structured guidance to navigate IFRS, solvency rules, and evolving compliance expectations with confidence.",
  },
];

export const scienceReadyExpertiseData = [
  {
    icon: "/assets/icons/risk.png",
    title: "Regulatory Insight",
    text: "Guiding teams through FDA, EMA, and regional requirements that shorten approval timelines and reduce compliance risks.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Trial Acceleration",
    text: "Improving protocol design, site readiness, and patient pathways to cut recruitment delays and deliver stronger clinical outcomes.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Cost Efficiency",
    text: "Aligning R&D spend, supply-chain operations, and portfolio priorities to manage rising costs without slowing innovation.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Market Readiness",
    text: "Building evidence, pricing, and access strategies that help new therapies secure reimbursement and reach patients sooner.",
  },
];
export const privateEquityData = [
  {
    icon: "/assets/icons/risk.png",
    title: "Deal Clarity",
    text: "Sharper financial, operational, and market insights that help investors validate assumptions and price assets.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Value Playbooks",
    text: "Clear post-acquisition roadmaps focused on EBITDA uplift, cash-flow discipline, digital efficiency, and leadership alignment.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Risk Visibility",
    text: "Forward-looking analysis of compliance, market exposure, and operational vulnerabilities to protect investment outcomes.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Exit Readiness",
    text: "Strategic preparation that strengthens reporting, optimizes performance metrics, and positions assets for stronger valuations.",
  },
];

export const professionalServiceData = [
  {
    icon: "/assets/icons/risk.png",
    title: "Margin Control",
    text: "Optimizing pricing, cost structures, and engagement economics to protect profitability across volatile demand cycles.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Delivery Excellence",
    text: "Improving project governance, workflow efficiency, and service quality to enhance client satisfaction and retention.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Talent Optimization",
    text: "Strengthening capacity planning, utilization forecasting, and skill deployment for a more productive workforce.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Digital Acceleration",
    text: "Enabling CRM upgrades, workflow automation, and analytics adoption that support faster, smarter decision-making.",
  },
];

export const publicSectorData = [
  {
    icon: "/assets/icons/risk.png",
    title: "Fiscal Discipline",
    text: "Improving budgeting accuracy, minimizing leakages, and enabling data-driven resource allocation across departments.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Service Efficiency",
    text: "Streamlining processes, reducing turnaround times, and enhancing responsiveness for better citizen experience.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Digital Modernization",
    text: "Supporting e-governance platforms, automation, and integrated systems that improve transparency and speed.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Governance Strength",
    text: "Enhancing compliance frameworks, reporting structures, and performance oversight to reduce operational risk.",
  },
];

export const realEstateConstructionData = [
  {
    icon: "/assets/icons/risk.png",
    title: "Capital Efficiency",
    text: "Re-engineering how capital moves across land acquisition, approvals, and build cycles to prevent value erosion.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Speed Optimization",
    text: "Designing execution models that keep contractors, materials, and machinery moving as a single synchronized system.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Improved Asset",
    text: "Transforming buildings into performance-driven assets using digital diagnostics and lifecycle interventions.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Compliance Shield",
    text: "Embedding environmental and safety requirements into the earliest design, so projects stay approval ready.",
  },
];

export const mediaAndEntertainmentData = [
  {
    icon: "/assets/icons/risk.png",
    title: "Content Intelligence",
    text: "Using audience signals, genre performance, and platform behavior to guide smarter content investments and reduce creative risk.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Distribution Architecture",
    text: "Designing OTT, social, and broadcast channel strategies that strengthen engagement, cut churn & expand reach.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Production Economics",
    text: "Reworking budgets, vendor structures, and shoot workflows to control costs while maintaining creative quality.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Monetization Engineering",
    text: "Optimizing rights, pricing, and multi-market deals to build stable, predictable, and diversified revenue streams.",
  },
];
export const technologyData = [
  {
    icon: "/assets/icons/risk.png",
    title: "Product Velocity",
    text: "Accelerating feature delivery by removing engineering blockers and tightening cross-team execution.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Market Fit",
    text: "Sharpening customer understanding, use cases, and value propositions to drive real adoption.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Revenue Engine",
    text: "Strengthening pricing, packaging, and go-to-market funnels to convert demand into predictable revenue.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Scalable Architecture",
    text: "Fixing cloud waste, system fragility, and tech debt layers so teams can grow without breaking infrastructure.",
  },
];
export const telecommunicationData = [
  {
    icon: "/assets/icons/risk.png",
    title: "Network Economics",
    text: "Reducing rollout waste and optimizing 5G utilization so operators invest where performance and demand actually meet.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Customer Experience",
    text: "Fixing real churn through smoother digital journeys and service quality that stays consistent during peak load.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Margin Resilience",
    text: "Strengthening profitability by redesigning operating models and aligning pricing with real network value.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Spectrum Strategy",
    text: "Turning spectrum planning into a competitive advantage through smarter auction preparation & usage optimization.",
  },
];

